import React from 'react'
import cx from 'classnames'
import { VegaHeading } from '../../../vega/heading/Heading'
import { useTranslation } from 'react-i18next'
import style from './bankItemHeader.module.scss'
import { VegaIconBank } from '../../../vega/icon/Icon'
import { VegaTypo } from '../../../vega/typography/Typography'
import { FormatType } from '../../../../utils/translation/i18n'
import { PropTypes } from 'prop-types'
import { PaymentStatus } from '../../../../resources/constants/PaymentStatus'

/**
 * First line of the Bank Item, with the bank Icon in it
 */
const BankItemHeader = ({ lastEmissionDate, logo, lastStatus }) => {
	const { i18n, t } = useTranslation()
	const prefixTranslation = 'historyStatus'

	const status = lastStatus && PaymentStatus[lastStatus]
	return (
		<div className={cx(style.headingContainer)}>
			<div className={style.heading}>
				<VegaIconBank src={logo} placeholder={status?.statusTranslation} size={24} />
				<VegaHeading
					tag="h5"
					className={cx(style.title, { [style.loading]: !status?.statusTranslation })}
					label={
						status?.statusTranslation &&
						t(prefixTranslation + status.statusTranslation + 'Title')
					}
				/>
			</div>
			<div className={style.duration}>
				<VegaTypo
					label={i18n.format(lastEmissionDate, {
						type: FormatType.DATE,
						format: t('historyTimeFormat')
					})}
					width={50}
				/>
			</div>
		</div>
	)
}

BankItemHeader.propTypes = {
	/** Last status emitted by that partner */
	lastEmissionDate: PropTypes.string,
	/** The partner company logo */
	logo: PropTypes.string,
	/** Current status, to select the text */
	lastStatus: PropTypes.oneOf(Object.keys(PaymentStatus))
}

export { BankItemHeader }
